import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from "@angular/common/http";
import { HttpClient } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TestComponent } from './test/test.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { FormsModule }   from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {TokenInterceptor} from './interceptor.module';

import {MenuComponent} from './menu/menu.component'
import {ReservComponent} from './reserv/reserv.component'
import { MenuForCalcComponent } from './menu-for-calc/menu-for-calc.component';
import { CalcBuyerComponent } from './calc-buyer/calc-buyer.component';
import { CalcWithoutChangeOwnerComponent } from './calc-without-change-owner/calc-without-change-owner.component'
import {NzSearchComponent} from './nz-search/nz-search.component'

import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { DataTablesModule } from 'angular-datatables';
import {NgxPaginationModule} from 'ngx-pagination'; 

const routes: Routes = [
  {path: '', redirectTo: "/", pathMatch: 'full'},
  {path: '', component:MenuForCalcComponent},
  // {path: '', component: MenuComponent},
  {path: 'dkp', component: TestComponent},
  {path: 'reserved', component: ReservComponent},
  {path: 'calculator-buyer', component: CalcBuyerComponent},
  {path: 'calculator-w-change-owner', component: CalcWithoutChangeOwnerComponent},
  {path: 'nz-search', component: NzSearchComponent},
  ];


@NgModule({
  declarations: [
    AppComponent,
    TestComponent,
    MenuComponent,
    ReservComponent,
    MenuForCalcComponent,
    CalcBuyerComponent,
    CalcWithoutChangeOwnerComponent,
    NzSearchComponent
  ],
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    RecaptchaModule,
    HttpClientModule,
    DataTablesModule,
    NgxPaginationModule,
  ],
  exports: [RouterModule,
    RecaptchaModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
  },
  {
    provide: RECAPTCHA_LANGUAGE,
    useValue: 'en',
  },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http);
// }